import { useEffect, RefObject, useCallback } from 'react'

export const useOutsideClick = <T extends HTMLElement>(
  ref: RefObject<T>,
  callback: () => void,
): void => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback()
      }
    },
    [ref, callback],
  )

  useEffect(() => {
    document?.addEventListener('mousedown', handleClickOutside)

    return () => {
      document?.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside])
}
